import {EventDispatcher} from '@megaphonenpm/mputils/src/EventDispatcher.js';
import {notEmpty, isNil} from '@megaphonenpm/mputils/src/utils.js';
import {addStyleSheet} from '@megaphonenpm/mputils/src/DOM.js';
import {get} from 'lodash-es';

/**
 * Base class for all components.
 */
export class Component extends EventDispatcher {
  constructor (props) {
    super();

    // Assign the properties supplied by props to this instance. This assignment allows
    // component subclasses to initialize properties before this.build() occurs.
    if (notEmpty(props)) {
      Object.keys(props).forEach(key => this[key] = props[key]);
    }

    this.view = null;
    this.build();

    // One-time CSS setup
    if (isNil(get(this.constructor, 'CSS_INITED'))) {
      this.initCSS();
      this.constructor.CSS_INITED = true;
    }
  }

  /**
   * Creates the DOM elements and initializes the component. To be implemented by subclasses.
   */
  build () {
  }

  initCSS () {
    let css = this.getCSS();
    if (notEmpty(css)) {
      let stylesheetName = `component-${this.constructor.name}`;
      let styleElement = addStyleSheet(stylesheetName);
      styleElement.textContent = css;
    }
  }

  getCSS () {
    return null;
  }
}